<template>
    <footer class="dark-footer skin-dark-footer style-2" role="contentinfo" aria-label="Sidefod">
        <div class="footer-middle">
            <div class="container">
                <div class="row">
                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-12">
                        <div class="footer_widget">
                            <img :src="logo" class="img-footer small mb-2" :alt="siteName || 'YOKO logo'" loading="lazy" decoding="async" />
                            <!--<div class="address mt-3">
                              <a href="mailto:mail@yoko.dk" style="color: #ffffff;" target="_blank" rel="noopener" aria-label="Send e-mail til mail@yoko.dk" title="mail@yoko.dk">mail@yoko.dk</a>
                            </div>-->
                            <div class="address mt-3">
                                <ul class="list-inline" aria-label="Følg os">
                                    <li>
                                        <a href="https://facebook.com/yokowebshop" target="_blank" rel="noopener noreferrer" aria-label="Følg os på Facebook" title="Facebook">
                                            <i class="fa-brands fa-facebook-f" aria-hidden="true"></i>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://instagram.com/yokowebshop" target="_blank" rel="noopener noreferrer" aria-label="Følg os på Instagram" title="Instagram">
                                            <i class="fa-brands fa-instagram" aria-hidden="true"></i>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    
                    <div class="col-xl-4 col-lg-4 col-md-4 col-sm-12">
                        <div class="footer_widget">
                            <h4 class="widget_title">Kategorier</h4>
                            <ul class="footer-menu" aria-label="Produktkategorier">
                                <li v-for="category in Categories" :key="category.id">
                                    <router-link :to="'/shop/' + category.name" :title="category.displayname" :aria-label="'Gå til ' + category.displayname">
                                        {{ category.displayname }}
                                    </router-link>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div class="col-xl-2 col-lg-2 col-md-2 col-sm-12">
                        <div class="footer_widget">
                            <h4 class="widget_title">YOKO</h4>
                            <ul class="footer-menu" aria-label="YOKO sider">
                                <li :class="current === '/shop' ? 'active' : ''"><router-link to="/om-os" title="Om YOKO" aria-label="Om YOKO">OM</router-link></li>
                                <li :class="current === '/shop' ? 'active' : ''"><router-link to="/kontakt" title="Kontakt YOKO" aria-label="Kontakt YOKO">KONTAKT</router-link></li>
                                <li :class="current === '/docs' ? 'active' : ''"><router-link to="/opret-webshop" title="Opret webshop" aria-label="Opret webshop">OPRET WEBSHOP</router-link></li>
                            </ul>
                        </div>
                    </div>
                    
                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-12">
                        <div class="footer_widget">
                            <h4 class="widget_title">Hold dig opdateret</h4>
                            <p>Modtag mails om nye designere, markeder, udsalg og andre relevante nyheder om vores kunstnere.</p>
                            <div class="foot-news-last">
                                <div class="input-group">
                                    <input v-model="email" type="email" name="newsletter_email" class="form-control" placeholder="Indtast e-mail" aria-label="Indtast e-mail til nyhedsbrev" autocomplete="email" inputmode="email">
                                    <div class="input-group-append">
                                        <button @click="subscribeUser" :disabled="isLoading" type="button" class="input-group-text rounded-0 text-light" aria-label="Tilmeld nyhedsbrev" title="Tilmeld">
                                            <i v-if="!isSuccess" class="lni lni-arrow-right" aria-hidden="true"></i>
                                            <i v-else class="lni lni-thumbs-up" aria-hidden="true"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                        
                </div>
            </div>
        </div>
        
        <div class="footer-bottom">
            <div class="container">
                <div class="row align-items-center">
                    <div class="col-lg-12 col-md-12 text-center">
                        <p class="mb-0">
                          © {{ new Date().getFullYear() }} YOKO er skabt af
                          <a href="https://shup.dk" style="color:#ffffff;text-decoration: none;" target="_blank" rel="noopener noreferrer" aria-label="Besøg SHUP" title="Start din egen webshop med SHUP">SHUP</a> 
                          <i class="fa fa-heart" style="margin-left: 5px;color:#ffffff;" aria-hidden="true"></i>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </footer>
</template>

<script setup>
    import { ref } from 'vue';
    import logo from '@/assets/img/footer-logo.png';
    import { Categories } from '@/data/data';

    const email = ref('');
    const isLoading = ref(false);
    const isSuccess = ref(false);
    const klaviyoListId = 'TwEDCm';

    async function subscribeUser() {
        if (!email.value || !email.value.includes('@')) {
            alert('Please enter a valid email address.');
            return;
        }

        isLoading.value = true;
        isSuccess.value = false;

        const formData = new FormData();
        formData.append('list', klaviyoListId);
        formData.append('email', email.value);

        try {
            const response = await fetch('https://apiv2.shup.dk/tools/klaviyo/engine.php', {
                method: 'POST',
                body: formData
            });

            if (response.ok) {
                isSuccess.value = true;
                email.value = '';
                setTimeout(() => {
                    isSuccess.value = false;
                }, 3000);
            } else {
                alert('An error occurred. Please try again later.');
            }
        } catch (error) {
            console.error('Subscription error:', error);
            alert('Could not connect to the server. Please check your connection.');
        } finally {
            isLoading.value = false;
        }
    }
</script>

<style scoped>
/* Make links distinguishable without relying on color */
.footer-bottom p a {
  text-decoration: underline;
  text-underline-offset: 0.15em;
  text-decoration-thickness: 2px;
}

/* Visible keyboard focus */
.footer-bottom p a:focus-visible,
.footer-menu a:focus-visible,
.address a:focus-visible {
  outline: 2px solid currentColor;
  outline-offset: 2px;
  border-radius: 2px;
}
</style>